import moment from 'moment';
import { IPagination } from '../../../types/pagination';
import { _initialInvoice, _initialPaginatedInvoices } from '../../project/reducers/accountingReducer';
import { IProjectInvoice } from '../../project/types/invoice';
import { GlobalAccountingActions } from '../actions/accountingActions';
import * as constants from '../actions/constants';
import { _initialDirectCostInvoice } from './../../project/reducers/accountingReducer';
import { IDirectCostInvoice } from './../../project/types/invoice';
import { IAccountingChartData, IPeriodType } from './../types/accounting';

export const _initialChartData: IAccountingChartData = {
  data: [],
  categories: []
}

export const _initialPaginatedDCInvoices: IPagination<IDirectCostInvoice[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

/** SPONSOR AND PTC */
export const paginatedInvoices = (state: IPagination<IProjectInvoice[]> = _initialPaginatedInvoices, action: GlobalAccountingActions): IPagination<IProjectInvoice[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_INVOICES_SUCCESS:
      return action.data

      case constants.CREATE_INVOICE_SUCCESS:
        return {...state, results: [...state.results, action.invoice]}

      case constants.UPDATE_INVOICE_SUCCESS: {
        const invoices = state.results.map(a => {
          if (+a.id === +action.invoice.id) {
            return action.invoice
          }
          return a
        })

        return {...state, results: invoices}
      }

      case constants.DELETE_INVOICE_SUCCESS:
        return {...state, results: state.results.filter(i => i.id !== action.invoice.id)}

    default:
      return state
  }
}

export const paginatedInvoiceActivePage = (state = 1, action: GlobalAccountingActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_INVOICES_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const selectedInvoice = (state: IProjectInvoice = _initialInvoice, action: GlobalAccountingActions): IProjectInvoice => {
  switch (action.type) {
    case constants.SET_SELECTED_INVOICE:
    case constants.CREATE_INVOICE_SUCCESS:
    case constants.UPDATE_INVOICE_SUCCESS:
    case constants.GET_INVOICE_SUCCESS:
      return action.invoice

    case constants.DELETE_INVOICE_SUCCESS:
      return _initialInvoice

    default:
      return state
  }
}

export const accountingChartData = (state: IAccountingChartData = _initialChartData, action: GlobalAccountingActions): IAccountingChartData => {
  switch (action.type) {
    case constants.GET_ACCOUNTING_CHART_DATA_SUCCESS: {
      let _series = action.data.data
      const _emptyData = action.data.data.map(data => data.data.filter(d => d !== 0).length !== 0 ? { name: '', data: [] } : data)
      if (_emptyData.filter(i => i.name).length !== 0) {
        _emptyData.forEach(item => {
          _series = action.data.data.filter(d => d.name !== item.name)
        })
      }
      return { ...action.data, data: _series }
    }
    case constants.SELECT_TAB:
      return _initialChartData

    default:
      return state
  }
}

export const invoiceYears = (state: number[] = [], action: GlobalAccountingActions): number[] => {
  switch (action.type) {
    case constants.GET_INVOICE_YEARS_SUCCESS:
      return action.years

    default:
      return state
  }
}

/** DC */
export const paginatedDCInvoices = (state: IPagination<IDirectCostInvoice[]> = _initialPaginatedDCInvoices, action: GlobalAccountingActions): IPagination<IDirectCostInvoice[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_DC_INVOICES_SUCCESS: {
      const data = action.data.results.map(i => {
        return { ...i, percent_of_total: +i.invoiced_amount !== 0 && +i.direct_cost_total !== 0 ? ((+i.invoiced_amount / +i.direct_cost_total) * 100) : 0 }
      })
      return { ...action.data, results: data }
    }

    case constants.CREATE_DC_INVOICE_SUCCESS:
      return { ...state, results: [...state.results, { ...action.invoice, percent_of_total: +action.invoice.invoiced_amount !== 0 && +action.invoice.direct_cost_total !== 0 ? ((+action.invoice.invoiced_amount / +action.invoice.direct_cost_total) * 100) : 0 }] }

    case constants.UPDATE_DC_INVOICE_SUCCESS: {
      const invoices = state.results.map(a => {
        if (+a.id === +action.invoice.id) {
          return { ...action.invoice, percent_of_total: +action.invoice.invoiced_amount !== 0 && +action.invoice.direct_cost_total !== 0 ? ((+action.invoice.invoiced_amount / +action.invoice.direct_cost_total) * 100) : 0 }
        }
        return a
      })

      return { ...state, results: invoices }
    }

    case constants.DELETE_DC_INVOICE_SUCCESS:
      return { ...state, results: state.results.filter(i => i.id !== action.invoice.id) }

    default:
      return state
  }
}

export const paginatedDCInvoiceActivePage = (state = 1, action: GlobalAccountingActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_DC_INVOICES_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const selectedDCInvoice = (state: IDirectCostInvoice = _initialDirectCostInvoice, action: GlobalAccountingActions): IDirectCostInvoice => {
  switch (action.type) {
    case constants.SET_SELECTED_DC_INVOICE:
    case constants.CREATE_DC_INVOICE_SUCCESS:
    case constants.UPDATE_DC_INVOICE_SUCCESS:
    case constants.GET_DC_INVOICE_SUCCESS:
      return  { ...action.invoice, percent_of_total: +action.invoice.invoiced_amount !== 0 && +action.invoice.direct_cost_total !== 0 ? ((+action.invoice.invoiced_amount / +action.invoice.direct_cost_total) * 100) : 0 }

    case constants.DELETE_DC_INVOICE_SUCCESS:
      return _initialDirectCostInvoice

    default:
      return state
  }
}

export const accountingReceiptsChartData = (state: IAccountingChartData = _initialChartData, action: GlobalAccountingActions): IAccountingChartData => {
  switch (action.type) {
    case constants.GET_ACCOUNTING_RECEIPTS_CHART_DATA_SUCCESS: {
      let _series = action.data.data
      const _emptyData = action.data.data.map(data => data.data.filter(d => d !== 0).length !== 0 ? { name: '', data: [] } : data)
      if (_emptyData.filter(i => i.name).length !== 0) {
        _emptyData.forEach(item => {
          _series = action.data.data.filter(d => d.name !== item.name)
        })
      }
      return { ...action.data, data: _series }
    }
    case constants.SELECT_TAB:
      return _initialChartData

    default:
      return state
  }
}

/** ALL */
export const periodType = (state: IPeriodType = { period: 'year' }, action: GlobalAccountingActions): IPeriodType => {
  switch (action.type) {
    case constants.SET_PERIOD_TYPE:
      return action.period

    default:
      return state
  }
}

export const selectedYear = (state = moment().year(), action: GlobalAccountingActions): number => {
  switch (action.type) {
    case constants.SET_SELECTED_YEAR:
      return action.year

    default:
      return state
  }
}

export const selectedTab = (state = 'receipts', action: GlobalAccountingActions): string => {
  switch (action.type) {
    case constants.SELECT_TAB:
      return action.tab

    default:
      return state
  }
}
